import { Button } from '../../common/components/button'
import { Select } from '../../common/components/select'
import { Slider } from '../../common/components/slider'
import { reportDataSetService } from '../editor/report-data-set.service'

import { useStyles } from './filter.style'

export const FILTER_SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
}

export const FilterContainer = function ({ children, layout = 'grid', showReset = false, onReset }) {
  const classes = useStyles()

  return <div>
    {showReset && onReset && <div className={classes.header}>
      <Button
        variant="link"
        className={classes.reset}
        tooltipLabel="Reset Filters"
        onClick={onReset}
      >Reset</Button>
    </div>}
    <div className={layout === 'grid' ? classes.controlGrid : classes.controlFlex}>
      {children}
    </div>
  </div>
}

export const Filter = function ({
  className,
  filter,
  size,
  displayOnly,
  onChange = () => {},
  onOpen = () => {},
  onClose = () => {}
}) {
  const classes = useStyles()

  const { key, label, options = [], selected = {} } = filter

  const getOptionLabel = (value) => reportDataSetService.getFilterOptionLabel(filter, value)

  return displayOnly ? (
    <div className={classes.displayCol}>
      <DisplayFilter data-qa={`filter-label-${key}`} label={label}>
        {getOptionLabel(selected.value)}
      </DisplayFilter>
    </div>
  ) : (
    <div className={classes.controlCol}>
      <div data-qa={`filter-${key}`} className={className ? `${className} ${classes.control}` : classes.control}>
        <label className={classes.controlLabel}>{label}</label>
        <Select
          size={size}
          options={options.filter(({ hide }) => (!hide))}
          value={options.find(({ value }) => value === selected.value)}
          onChange={({ value }) => onChange(key, value, getOptionLabel(value))}
          onOpen={onOpen}
          onClose={onClose}
        />
      </div>
    </div>
  )
}

export const SliderFilter = function ({
  className,
  filter,
  size,
  dateMode,
  dateValueFormat,
  min,
  max,
  marks,
  displayOnly,
  onChange = () => {}
}) {
  const classes = useStyles()

  const { key, label, selected = {} } = filter

  const getOptionLabel = (value) => reportDataSetService.getSliderFilterOptionLabel(filter, value, { dateMode, dateValueFormat })

  return displayOnly ? (
    <div className={classes.displayCol}>
      <DisplayFilter data-qa={`filter-slider-label-${key}`} label={label}>
        {getOptionLabel(selected.value)}
      </DisplayFilter>
    </div>
  ) : (
    <div className={classes.controlCol}>
      <div data-qa={`filter-slider-${key}`} className={className ? `${className} ${classes.control}` : classes.control}>
        <label className={classes.controlLabel}>{label}</label>
        <Slider
          size={size}
          dateMode={dateMode}
          dateValueFormat={dateValueFormat}
          value={selected.value}
          min={min}
          max={max}
          marks={marks}
          onChange={(event, value) => onChange(key, value, getOptionLabel(value))}
        />
      </div>
    </div>
  )
}

export const ThresholdFilter = function ({
  className,
  sliderClassName,
  filter,
  thresholds = [],
  size,
  displayOnly,
  onChange = () => {},
  onThresholdChange = () => {},
  onThresholdCommitted = () => {},
  onOpen = () => {},
  onClose = () => {}
}) {
  const classes = useStyles()

  const { dataSource, key, label, options = [], sliderLabel, selected = {} } = filter

  let controlLabel = label
  if (sliderLabel) {
    controlLabel = `${controlLabel} (${sliderLabel})`
  }

  const getOptionLabel = (key, value) => reportDataSetService.getThresholdFilterOptionLabel(filter, key, value)

  return displayOnly ? (
    <div className={classes.displayCol}>
      <DisplayFilter data-qa={`filter-label-${key}`} label={label}>
        {getOptionLabel(selected.key, selected.value)}
      </DisplayFilter>
    </div>
  ) : (
    <div className={classes.controlColSpan2}>
      <div className={classes.thresholdControl}>
        <label className={classes.controlLabel}>{controlLabel}</label>
        <div data-qa={`filter-${key}`} className={className ? `${className} ${classes.control}` : classes.control}>
          <Select
            size={size}
            options={options.filter(({ hide }) => (!hide))}
            value={options.find(({ value: thresholdKey }) => thresholdKey === selected.key)}
            onChange={({ value: thresholdKey }) => {
              const defaultThresholdValue = thresholds[0]?.value
              onChange(dataSource, key, thresholdKey, defaultThresholdValue, getOptionLabel(thresholdKey, defaultThresholdValue))
            }}
            onOpen={onOpen}
            onClose={onClose}
          />
        </div>
        <div data-qa={`filter-${key}-slider`} className={sliderClassName ? `${sliderClassName} ${classes.slider}` : classes.slider}>
          <Slider
            size={size}
            value={selected.value}
            min={0}
            max={1}
            marks={thresholds}
            step={0.01}
            track="inverted"
            onChange={(event, thresholdValue) => {
              // onChange is called on every mouse move
              if (thresholdValue !== selected.value) {
                onThresholdChange(dataSource, key, selected.key, thresholdValue, getOptionLabel(selected.key, thresholdValue))
              }
            }}
            onChangeCommitted={(event, thresholdValue) => {
              onThresholdCommitted(dataSource, key, selected.key, thresholdValue, getOptionLabel(selected.key, thresholdValue))
            }}
            valueLabelFormat={(value) => {
              return `${Math.round(value * 100)}%`
            }}
          />
        </div>
      </div>
    </div>
  )
}

export const DisplayFilter = function ({ label, children, ...props }) {
  const classes = useStyles()

  return <label className={classes.displayFilter} {...props}>
    <span className={classes.displayLabel}>{label}</span>:
    <span className={classes.displayValue}>{children}</span>
  </label>
}
